import React from 'react';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';
import { TrendingUp, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Investors = () => {
  const highlights = [
    { metric: '3.5x', label: 'YoY Active Student Growth', sub: 'Driven by EV & IT courses', color: 'text-emerald-600', bg: 'bg-emerald-50' },
    { metric: '92%', label: 'Course Completion Rate', sub: 'Industry-leading engagement', color: 'text-blue-600', bg: 'bg-blue-50' },
    { metric: '₹15M+', label: 'Annual Revenue Run Rate', sub: 'Profitable unit economics', color: 'text-purple-600', bg: 'bg-purple-50' },
    { metric: '50,000+', label: 'Total Enrolled Learners', sub: 'Across 150+ cities in India', color: 'text-amber-600', bg: 'bg-amber-50' }
  ];

  const initiatives = [
    { title: 'AI-Powered Personalization', desc: 'Integrating generative AI to create customized quiz evaluations and course recommendation engines.' },
    { title: 'Enterprise & Institutional Upskilling', desc: 'Partnering with universities and engineering colleges to integrate E-Learning Hub certifications.' },
    { title: 'Global Market Expansion', desc: 'Scaling course collections for international students across Southeast Asia and Middle East markets.' }
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-14 sm:pt-16">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-5 w-full space-y-3.5 sm:space-y-5">
        
        {/* Compact Hero Banner */}
        <div className="bg-gradient-to-r from-emerald-900 via-teal-900 to-gray-900 rounded-xl sm:rounded-2xl p-3.5 sm:py-4 sm:px-6 md:py-4 md:px-6 text-white text-center space-y-1.5 shadow-xs relative overflow-hidden">
          <div className="relative z-10 max-w-2xl mx-auto space-y-1">
            <span className="bg-emerald-500/30 text-emerald-300 border border-emerald-400/40 text-[9px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wider">
              Investor Relations & Growth
            </span>
            <h1 className="text-sm sm:text-lg md:text-xl font-black leading-snug">Building the Future of Technical E-Learning</h1>
            <p className="text-gray-300 text-[11px] sm:text-xs leading-snug">
              E-Learning Hub is scaling high-impact, industry-aligned technical online education across Electric Vehicles, Software Development, Mechanical, Civil, and NDT engineering.
            </p>
          </div>
        </div>

        {/* 2-Column Responsive Highlights Grid on Mobile */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-3">
          {highlights.map((item, idx) => (
            <div key={idx} className="bg-white p-3 sm:p-4 rounded-xl border border-gray-100 shadow-2xs text-center space-y-1 hover:shadow-xs transition-all">
              <span className={`inline-block p-1.5 sm:p-2 rounded-lg ${item.bg}`}>
                <TrendingUp className={`${item.color} w-3.5 h-3.5 sm:w-4 sm:h-4`} />
              </span>
              <h3 className={`text-base sm:text-xl font-black ${item.color}`}>{item.metric}</h3>
              <p className="text-[10px] font-bold text-gray-900 uppercase tracking-tight leading-tight">{item.label}</p>
            </div>
          ))}
        </div>

        {/* Growth Initiatives */}
        <div className="bg-white p-3.5 sm:p-5 rounded-xl sm:rounded-2xl border border-gray-100 shadow-2xs space-y-3">
          <div className="border-b border-gray-100 pb-2">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">Key Strategic Growth Initiatives</h2>
            <p className="text-[11px] text-gray-500 mt-0.5">How we are expanding our market reach and technology edge</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 sm:gap-3">
            {initiatives.map((item, idx) => (
              <div key={idx} className="p-3 sm:p-4 rounded-xl bg-gray-50/80 border border-gray-100 space-y-1">
                <span className="text-[9px] font-extrabold text-emerald-700 uppercase">Initiative #{idx + 1}</span>
                <h3 className="font-bold text-gray-900 text-xs sm:text-sm">{item.title}</h3>
                <p className="text-[11px] text-gray-500 leading-normal">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Investor Contact Banner */}
        <div className="bg-gradient-to-r from-emerald-800 to-teal-900 text-white rounded-xl sm:rounded-2xl p-3.5 sm:p-5 flex flex-col sm:flex-row items-center justify-between gap-3 shadow-2xs">
          <div className="space-y-0.5 text-center sm:text-left">
            <h3 className="text-xs sm:text-base font-bold">Interested in Investing or Strategic Partnership?</h3>
            <p className="text-[11px] text-emerald-100/90 max-w-xl">Contact our executive team for financial reports, pitch deck, and investor relations inquiries.</p>
          </div>
          <Link
            to="/contact-us"
            className="w-full sm:w-auto shrink-0 bg-white text-emerald-900 font-bold px-4 py-2 rounded-lg text-xs hover:bg-emerald-50 transition-colors flex items-center justify-center gap-1.5 shadow-xs cursor-pointer"
          >
            <Mail size={14} /> Contact Investor Relations
          </Link>
        </div>

      </main>
      <Footer />
    </div>
  );
};

export default Investors;
